import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'

export const IconButtonWrapper = styled(Box)(({ theme }) => (`
  width: 60px;
  height: 60px;
  transform: scale(0.6);
  position: relative;
`))

export const IconWrapper = styled(Box)(({ theme }) => (`
  width: 60px;
  height: 60px;
  display:flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top:0;
  left:0;
`))

export const PinWrapper = styled(Box)(({ theme }) => (`
  width: 30px;
  position: absolute;
  top: -10px;
  left: 10px;
`))
